var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStandard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 26.196,
    viewBox: "0 0 21 26.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13709",
    "data-name": "Grupo 13709",
    transform: "translate(-360.5 -2624.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_11112",
    "data-name": "Ret\\xE2ngulo 11112",
    transform: "translate(366 2627)",
    fill: "#004D43",
    stroke: "#004D43",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 11,
    height: 11,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3642",
    "data-name": "Caminho 3642",
    d: "M15,2C9.471,2,5,5.913,5,10.75,5,17.313,15,27,15,27s10-9.687,10-16.25C25,5.913,20.529,2,15,2Zm0,11.875a3.372,3.372,0,0,1-3.571-3.125A3.372,3.372,0,0,1,15,7.625a3.372,3.372,0,0,1,3.571,3.125A3.372,3.372,0,0,1,15,13.875Z",
    transform: "translate(356 2623)",
    fill: "#00B39B",
    stroke: "#004D43",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandard);
export default __webpack_public_path__ + "static/media/standard.b0ad3bd603c35e25762d8f5e57b5f7cf.svg";
export { ForwardRef as ReactComponent };